module.exports = __webpack_public_path__ + "img/hop-icons.fe4ed03b.svg";